import styles from './ChatSeparator.module.css';
import { Text } from '@/_components';
import { useMemo, type FC, type ReactNode } from 'react';
import type { ChatSeparatorProps } from './ChatSeparator.types';
import { getClasses } from '@/_utils/classnames';

export const ChatSeparator: FC<ChatSeparatorProps> = ({ date, isLeft }) => {
  const chatSeparatorClasses: string = getClasses(styles.chatSeparator, {
    [styles.chatSeparatorLeft]: isLeft,
  });

  const renderDate: ReactNode = useMemo(() => {
    if (!date) return '';

    if (isLeft) {
      return (
        <Text type="tiny" className={styles.chatSeparator__date}>
          {date}
        </Text>
      );
    }

    return (
      <Text type="tiny" className={styles.chatSeparator__date}>
        {date}
      </Text>
    );
  }, [date, isLeft]);

  return (
    <div className={chatSeparatorClasses} data-component="ChatSeparator">
      {renderDate}
    </div>
  );
};
